<template>
  <div class="px-3 pt-2">
    <div class="d-flex align-items-center justify-content-between gap-4 mb-4 pb-2">
      <a :href="`${basePath}/new`" class="btn btn-primary gap-2 rounded ml-auto">
        <i class="far fa-plus" />
        New Configuration
      </a>
    </div>

    <FilterComponent :fields="fields" @onFilterChange="onFilterChange" class="mb-4 pb-2" />

    <VueSlimTable
      ref="table"
      :source="getAuditReportConfigurations"
      :columns="columns"
      class="table m-0 table-of-audit-configurations">
      <template #row="{ row }">
        <TableRow :row="row" :base-path="basePath" :api-base-path="apiBasePath" @reload="reload" />
      </template>
      <template #pagination>
        <Pagination class="pb-0"
          :page="currentPage"
          :per-page="perPage"
          :total-count="totalCount"
          @updatePage="updatePageNumber" />
      </template>
    </VueSlimTable>
  </div>
</template>

<script>
import axiosTransform from 'common/axios'
import Pagination from 'vue_widgets/components/pagination'
import FilterComponent from 'vue_widgets/components/filter'
import TableRow from './configuration_row'

export default {
  components: { FilterComponent, TableRow, Pagination },
  props: {
    basePath: { type: String, required: true },
    apiBasePath: { type: String, required: true },
    locations: { type: Array, default: () => []}
  },
  data() {
    return {
      currentPage: 1,
      totalCount: 0,
      perPage: 20,

      fields: [{
        type: 'search',
        key: 'by_configuration',
        title: 'Audit configuration',
        classes: 'w-100',
        placeholder: 'Type a name of configuration'
      }, {
        type: 'select',
        key: 'by_location',
        title: 'Location',
        classes: 'w-100',
        placeholder: 'All',
        options: this.locations,
        trackBy: 'id',
        label: 'name',
        searchable: true,
        showLabels: false,
        allowEmpty: true,
        multiple: true,
        maxHeight: 540
      }, {
        type: 'search',
        key: 'by_keyword',
        title: 'Keyword search',
        classes: 'w-100',
        placeholder: 'Type a keyword'
      }]
    }
  },
  created() {
    this.columns = [
      { key: 'name', title: 'Name', orderable: false },
      { key: 'locationName', title: 'Location', orderable: false },
      { key: 'keywords', title: 'Keyword', orderable: false },
      { key: 'competitors', title: 'Competitors', orderable: false },
      { key: 'status', title: 'Status', orderable: false },
      { key: 'schedule', title: 'Schedule', orderable: false },
      { key: 'lastReportCreatedAt', title: 'Last audit', orderable: false },
      { key: 'scheduleAt', title: 'Next audit', orderable: false },
      { key: 'reportsCount', title: 'Audits', orderable: false },
      { key: 'actions', title: '' }
    ]
  },
  methods: {
    getAuditReportConfigurations() {
      return axios.get(this.apiBasePath, {
        params: {
          ...this.filter,
          page: this.currentPage
        },
        paramsSerializer(json) { return qs.stringify(json, { arrayFormat: 'brackets' }) },
        ...axiosTransform
      })
        .then((res) => {
          this.totalCount = parseInt(res.headers['total-count'], 10)
          return res.data
        })
    },
    updatePageNumber(page) {
      this.currentPage = page
      this.reload()
    },
    onFilterChange(newFilterValues) {
      this.filter = newFilterValues
      this.currentPage = 1
      this.reload()
    },
    reload() {
      this.$refs.table.reload()
    }
  }
}
</script>
